// ar/views/channelOta.js
export const channelOta = {
  common: {
    listing: "إعلان",
    back: "رجوع",
    close: "إغلاق",
    cancel: "إلغاء",
    flexible: "مرن",
    noResults: "لا توجد نتائج",
    deleteConn: "حذف الاتصال",
  },
  head: {
    manage: "إدارة {channel}",
    airbnbConfig: "إعدادات Airbnb",
    channelOptions: "خيارات القناة",
  },
  picker: {
    placeholder: "ابحث أو اختر إعلانًا…",
  },
  loading: {
    status: "جارٍ تحميل حالة القناة…",
    listings: "جارٍ تحميل إعلاناتك على Airbnb…",
    settings: "جارٍ تحميل إعدادات الإعلان…",
  },
  accounts: {
    title: "إلى أي من حساباتك في {channel}؟",
    lead: "لديك حساب {channel} متصل بالفعل. يمكنك إضافة هذا الإعلان إليه أو ربط حساب آخر. | لديك {n} حسابات {channel} متصلة. اختر الحساب الذي ينتمي إليه هذا الإعلان، أو اربط حسابًا آخر.",
    account: "الحساب {n}",
    empty: "لا توجد إعلانات بعد",
    andMore: "{list} و{rest} غير ذلك",
    newTitle: "ربط حساب {channel} آخر",
    newDesc: "للإعلانات الموجودة في حساب مختلف",
  },
  confirm: {
    title: "حذف اتصال {channel}",
    desc: "ستتم إزالة القناة من مدير القنوات ومن اتصالاتك النشطة.",
    coversPre: "يغطي هذا الاتصال ",
    coversCount: "{count} إعلان | {count} إعلانات",
    coversPost: " وسيتم فصله عنها جميعًا: {list}",
    purgePre: "هل تريد حذف الحجوزات المستوردة أيضًا؟ اختر من أي الغرف ",
    purgeNote: "(يمكن استعادتها)",
    selectAll: "الكل",
    unselectAll: "إلغاء الكل",
    delete: "حذف",
    detachOnly: "افصل هذا الإعلان فقط",
    deleteAll: "احذف وافصل إعلانًا واحدًا | احذف وافصل الإعلانات الـ{count}",
    deleteWithResv: "حذف (+{count} حجز) | حذف (+{count} حجوزات)",
  },
  gone: {
    title: "لم يعد هذا الاتصال موجودًا على القناة",
    desc: "تم حذف القناة في مدير القنوات. احذف هذا الاتصال لتتمكن من إعادة ربطه من ”الاتصال الآن“.",
  },
  menu: {
    channelOptDesc: "التفعيل أو الإيقاف المؤقت، تعديل الربط، المزامنة، سحب الحجوزات أو حذف الاتصال.",
    airbnbCfgDesc: "مواعيد الوصول/المغادرة، ومدة الإشعار، والأسعار، والتنظيف لكل إعلان.",
  },
  channel: {
    statusLabel: "حالة القناة",
    active: "نشطة",
    inactive: "غير نشطة",
    deactivate: "إيقاف القناة",
    activate: "تفعيل القناة",
    pending: "قيد المراجعة",
    hintPending: "القناة متصلة ولديها بياناتك بالفعل. يبقى أن تراجع القناة سكنك وتقبله؛ وعندها تُفعَّل تلقائيًا. يستغرق ذلك عادة بضعة أيام. وإن طال أكثر، راسلنا وسنتحقق من الأمر.",
    hintActive: "القناة نشطة: نرسل الأسعار والتوفّر. أوقفها مؤقتًا لإيقاف الإرسال دون فقدان الربط.",
    blockersTitle: "ينقص شيء قبل تفعيل القناة",
    blockersHint: "اضغط «اتصال» مرة أخرى في المعالج وسنصحّح ذلك ونعيد الإرسال.",
    hintInactive: "القناة متصلة لكنها متوقفة مؤقتًا. فعّلها لبدء إرسال الأسعار والتوفّر.",
    editTitle: "تعديل القناة",
    editDesc: "غيّر أو أضِف الغرف والأسعار المرتبطة بهذه القناة.",
    editBtn: "تعديل الربط",
    fullSyncTitle: "مزامنة كاملة",
    fullSyncDesc: "يعيد إرسال جميع الأسعار والتوفّر والقيود إلى القناة.",
    synced: "تمت المزامنة",
    sync: "مزامنة",
    extractTitle: "سحب الحجوزات المستقبلية",
    extractDesc: "استورد إلى WACheckin الحجوزات الموجودة لديك على القناة.",
    imported: "تم الاستيراد",
    extract: "سحب",
    resyncTitle: "إعادة استيراد الحجوزات",
    resyncDesc: "يعيد جلب جميع حجوزات القناة ويعيد تعيينها وفق الربط الحالي. استخدمه إذا اخترت الإعلان الخطأ أو كانت هناك حجوزات ناقصة.",
    resync: "إعادة استيراد",
  },
  cfg: {
    emptyNoListings: "لم تقم بمطابقة أي إعلان بعد. اذهب إلى <b>خيارات القناة ← تعديل الربط</b> لربط إعلاناتك على Airbnb بوحداتك.",
    emptyNoMapping: "لا يحتوي مكان الإقامة هذا على أي إعلان مطابق على Airbnb بعد. اذهب إلى <b>خيارات القناة ← تعديل الربط</b> وطابِق إعلانه لتتمكن من ضبط مواعيده وأسعاره هنا.",
  },
  arrival: {
    section: "الوصول والمغادرة",
    lead: "في أي أوقات وأيام يمكن لنزلائك الوصول والمغادرة.",
    checkInFrom: "تسجيل الوصول من",
    checkInFromTip: "أبكر وقت يمكن فيه للنزيل تسجيل الوصول.",
    checkInTo: "تسجيل الوصول حتى",
    checkInToTip: "أحدث وقت يمكن فيه للنزيل الوصول.",
    checkOut: "تسجيل المغادرة",
    checkOutTip: "آخر وقت يجب فيه على النزيل مغادرة مكان الإقامة.",
    unset: "غير محدد",
    daysIn: "أيام السماح بالوصول",
    daysInTip: "أيام الأسبوع التي يمكن فيها للنزيل تسجيل الوصول.",
    daysOut: "أيام السماح بالمغادرة",
    daysOutTip: "أيام الأسبوع التي يمكن فيها للنزيل تسجيل المغادرة.",
  },
  booking: {
    section: "الحجوزات",
    window: "نافذة التوفّر",
    windowTip: "مدى المدة المسبقة التي يُفتح فيها تقويمك للبيع. هذا ما يسميه Airbnb 'نافذة التوفّر' (12 شهرًا = 365 يومًا). وهي ليست الحد الأقصى لعدد الليالي لكل إقامة.",
    minLead: "الحد الأدنى للإشعار",
    minLeadTip: "كم من الوقت قبل الوصول يمكن إجراء الحجز. يمنع الحجوزات في اللحظة الأخيرة.",
    maxStay: "الحد الأقصى للإقامة",
    maxStayTip: "الحد الأقصى لعدد الليالي لكل حجز. هو 'الحد الأقصى لعدد الليالي' في Airbnb، ويختلف عن نافذة التوفّر.",
    turnover: "الأيام بين الحجوزات",
    turnoverTip: "الأيام التي تُحجب بين مغادرة والوصول التالي، للتنظيف والتحضير.",
  },
  rules: {
    section: "قواعد الحجز",
    cancelPolicy: "سياسة الإلغاء",
    cancelPolicyTip: "كم يمكن للنزيل استرداده إذا ألغى. مرنة = أكثر تساهلًا؛ صارمة = استرداد أقل.",
    whoCanBook: "من يمكنه الحجز",
    whoCanBookTip: "من يمكنه الحجز الفوري دون موافقتك المسبقة.",
  },
  prices: {
    section: "الأسعار",
    perNight: "السعر لكل ليلة",
    weekend: "سعر نهاية الأسبوع",
    weekendTip: "السعر ليومي الجمعة والسبت. اتركه مساويًا لسعر الليلة إن لم ترغب في التفرقة.",
    guestsIncluded: "النزلاء المشمولون",
    guestsIncludedTip: "عدد النزلاء دون تكلفة إضافية.",
    extraGuest: "سعر النزيل الإضافي",
    extraGuestTip: "التكلفة لكل نزيل إضافي، لكل ليلة، بعد المشمولين.",
  },
  cleaning: {
    section: "التنظيف",
    notePre: "املأ الحقلين لكي يدفع كل حجز رسوم التنظيف. يجب أن تكون رسوم الإقامة الطويلة ",
    noteStrong: "مساوية أو أعلى",
    notePost: " من رسوم الإقامة القصيرة. إذا تركت إحداها 0، فلن يدفع هذا النوع من الإقامة رسوم التنظيف.",
    long: "التنظيف · إقامة طويلة",
    longTip: "تُحتسب في الإقامات الطويلة. يجب أن تكون مساوية أو أعلى من رسوم الإقامة القصيرة.",
    short: "التنظيف · إقامة قصيرة",
    shortTip: "تُحتسب في الإقامات القصيرة (ليالٍ قليلة).",
    error: "يجب أن تكون رسوم تنظيف الإقامة الطويلة ({sym}{long}) مساوية أو أعلى من رسوم الإقامة القصيرة ({sym}{short}).",
  },
  tax: {
    section: "الضريبة السياحية",
    lead: "ضريبة محلية تحصّلها من النزيل وتُقرّ بها أنت (وليس Airbnb). اتركها 0 إذا لم تكن مطبّقة.",
    amount: "المبلغ",
    amountTip: "قيمة الضريبة. ضع 0 لعدم تطبيقها.",
    charged: "تُحتسب",
    chargedTip: "كيفية احتساب الضريبة: لكل نزيل وليلة، أو لكل ليلة، أو لكل نزيل.",
    perGuestNight: "لكل نزيل وليلة",
    perNight: "لكل ليلة",
    perGuest: "لكل نزيل",
    attestation: "أؤكد أن هذه المعلومات صحيحة وأنني أتحمّل مسؤولية تحصيل هذه الضريبة والإقرار بها.",
  },
  footer: {
    save: "حفظ الإعدادات",
    saving: "جارٍ الحفظ…",
  },
  opts: {
    noticeNoLimit: "بلا حد (كل التواريخ)",
    months: "{count} شهر | {count} أشهر",
    maxNoLimit: "بلا حد",
    nights: "{count} ليلة | {count} ليالي",
    maxNights: "الحد الأقصى ({count})",
    cancelModerate: "معتدلة",
    cancelFirm: "حازمة",
    cancelStrict: "صارمة",
    instantEveryone: "أي نزيل",
    instantWellReviewed: "نزلاء بتقييمات جيدة",
    instantVerified: "هوية موثّقة",
    instantReviewedVerified: "تقييمات + هوية",
    leadNone: "بلا إشعار مسبق",
    hours: "{count} ساعة | {count} ساعات",
    days: "{count} يوم | {count} أيام",
  },
  msg: {
    loadSettingsError: "تعذّر تحميل إعدادات الإعلان.",
    taxAttestationWarn: "حدّد خانة الإقرار لتطبيق الضريبة السياحية.",
    saveOk: "تم حفظ إعدادات Airbnb وإرسالها إلى القناة.",
    saveError: "تعذّر حفظ الإعدادات.",
    statusError: "تعذّر تحميل حالة القناة.",
    activated: "تم تفعيل القناة.",
    deactivated: "تم إيقاف القناة.",
    toggleError: "تعذّر تغيير حالة القناة.",
    resyncOk: "الحجوزات المُعاد استيرادها: {imported}.",
    resyncOkWarn: "الحجوزات المُعاد استيرادها: {imported} ({errors} مع تنبيه).",
    resyncError: "تعذّرت إعادة استيراد الحجوزات.",
    disconnectError: "تعذّر حذف الاتصال.",
    fullSyncOk: "تم إرسال المزامنة الكاملة.",
    extractOk: "تم استيراد الحجوزات المستقبلية.",
    actionError: "تعذّر تنفيذ الإجراء.",
  },
  rate: {
    apply: "تطبيق",
    or: "أو",
    usePlan: "استخدم أحد أسعارك…",
  },
};
